import React, {useEffect, useState} from 'react'
import RemiseForm from './components/RemiseForm'
import {ModeleRemise, modeleRemiseInitValues} from '../../../components/Models'
import {useNavigate, useParams} from 'react-router-dom'
import {editClientGroupe, getOneClientGroupe} from '../../../components/requests'

const RemiseEditPage = () => {
  const navigate = useNavigate()
  const [data, setData] = useState<ModeleRemise>(modeleRemiseInitValues)
  let {remiseId} = useParams()

  const getRemiseGroupe = () => {
    getOneClientGroupe(remiseId).then((resp: any) => {
      if (resp.status === 200 && resp.data) {
        const updatedData = Object.assign({
          ...data,
          idGroupeClient: resp.data.clientGroupe.id,
          taux: resp.data.tauxRemise,
          sauf: resp.data.sauf,
          offert: resp.data.fraisPortOffert,
        })
        setData({...updatedData})
      } else if (resp.status === 204) {
        const updatedData = Object.assign({
          ...data,
          idGroupeClient: remiseId,
        })
        setData(updatedData)
      }
    })
  }

  const submitForm = async (fieldsToUpdate: Partial<ModeleRemise>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleRemiseInitValues}, fieldsToUpdate)
    try {
      const groupeRequest = await editClientGroupe(remiseId, updatedData)
      if (groupeRequest?.status === 200) {
        if (groupeRequest?.data?.id !== undefined && groupeRequest?.data?.id !== null) {
          navigate(`/remise/groupe/liste`, {state: {edit: true}})
        }
      } else {
        navigate(`/remise/groupe/liste`, {state: {edit: false}})
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
    }
  }

  useEffect(() => {
    getRemiseGroupe()
  }, [remiseId])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Modifier la remise groupe client</h3>
        </div>
      </div>

      <div>
        <RemiseForm remiseId={remiseId} data={data} submitForm={submitForm} />
      </div>
    </div>
  )
}

export default RemiseEditPage
